import React, { useMemo } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { MessageCircle, Phone, Calendar, Clock, X, User, FileText } from 'lucide-react';

function brl(n) { return `R$ ${Number(n || 0).toFixed(2).replace('.', ',')}`; }

export default function BookingDetailModal({ booking, onClose }) {
  const whatsUrl = useMemo(() => {
    if (!booking) return '#';
    const num = (booking.customerPhone || '').replace(/\D/g, '');
    const msg = encodeURIComponent(`Olá ${booking.customerName}! Confirmando seu agendamento de ${booking.serviceName} em ${booking.date} às ${booking.time}.`);
    return num ? `https://wa.me/${num}?text=${msg}` : '#';
  }, [booking]);

  if (!booking) return null;

  return (
    <Dialog open={!!booking} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md bg-white">
        <DialogHeader>
          <DialogTitle className="font-display">{booking.customerName}</DialogTitle>
          <DialogDescription>{booking.serviceName}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 text-sm">
          <Row icon={Calendar} label="Data" value={`${booking.date} às ${booking.time}`} />
          <Row icon={Clock} label="Duração" value={`${booking.durationMin} min`} />
          {booking.price > 0 && <Row icon={FileText} label="Valor" value={brl(booking.price)} />}
          <Row icon={Phone} label="Telefone" value={booking.customerPhone} />
          <Row icon={User} label="Status" value={<StatusPill status={booking.status} />} />
          {booking.note && <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3 text-neutral-700">“{booking.note}”</div>}
        </div>
        <a href={whatsUrl} target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md h-10 font-semibold text-sm">
          <MessageCircle size={14} /> WhatsApp
        </a>
      </DialogContent>
    </Dialog>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center gap-3 p-2 border-b border-neutral-100 last:border-0">
      <Icon size={14} className="text-neutral-400" />
      <div className="text-xs text-neutral-500 w-20">{label}</div>
      <div className="flex-1 font-medium">{value}</div>
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    confirmed: { l: 'Confirmado', c: 'bg-emerald-100 text-emerald-700' },
    pending: { l: 'Aguardando', c: 'bg-amber-100 text-amber-700' },
    completed: { l: 'Concluído', c: 'bg-blue-100 text-blue-700' },
    cancelled: { l: 'Cancelado', c: 'bg-neutral-200 text-neutral-500' },
  };
  const s = map[status] || { l: status, c: 'bg-neutral-200 text-neutral-600' };
  return <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${s.c}`}>{s.l}</span>;
}
